import React from 'react';
import styles from './badge.module.css';

export const Badge = ({ text, type = 'default' }) => {
  const style = {
    default: {
      color: 'var(--neutral-dark-2)',
      borderColor: 'var(--neutral-dark-4)',
      backgroundColor: 'var(--neutral-dark-5)'
    },
    blue: {
      color: 'var(--blue-primary)',
      borderColor: 'var(--blue-light-4)',
      backgroundColor: 'var(--blue-light-6)'
    },
    green: {
      color: 'var(--green-dark)',
      borderColor: 'var(--green-light-4)',
      backgroundColor: 'var(--green-light-6)'
    },
    orange: {
      color: 'var(--orange-primary)',
      borderColor: 'var(--orange-light-4)',
      backgroundColor: 'var(--orange-light-5)'
    },
    red: {
      color: 'var(--red-dark)',
      borderColor: 'var(--red-light-4)',
      backgroundColor: 'var(--red-light-5)'
    }
  };

  return (
    <div className={styles.wrapper} style={style[type]}>
      {text}
    </div>
  );
};
